import classNames from 'classnames'
import type { FC } from 'react'

export type GridContainerProps = {
  mainColumn?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export const GridContainer: FC<GridContainerProps> = (props) => {
  const { children, className, ...otherProps } = props

  return (
    <div
      {...otherProps}
      className={classNames(
        'grid grid-cols-12 gap-8 max-lg:grid-cols-9 max-lg:gap-7 max-md:grid-cols-7 max-md:gap-4',
        className,
      )}
    >
      {children}
    </div>
  )
}
